module.exports = "/_next/static/images/payment-error-74eff38bb0d6d961bfdfc79432697e17.svg";